export default __webpack_public_path__ + "static/media/Dona Yeldo.e8d253ac.jpg";